<template>
    <div class="product-list">
        <SubNav v-bind:active="0"></SubNav>
        <div class="profile-img">
            <img :src="imgUrl" alt="">
        </div>
        <div class="list-width">
            <Row :gutter="0" justify="center">
                <Col span="4">
                    <div class="left-nav">
                        <h1>产品列表</h1>
                        <ul>
                            <li v-for="(item, index) in menuList">
                                <a v-on:click="toggleMenu(item, index)">{{ item.name }}</a>
                                <dl v-show="item.show">
                                    <dd v-for="(subItem, index) in item.list">
                                        <router-link tag="a" target="_blank" :to="{name:'product-details', query: { product_id: subItem.id }}">
                                            {{ subItem.name }}
                                        </router-link>

                                    </dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                </Col>
                <Col span="20">
                    <div style="padding: 0px 25px">
                        <div class="search-bar">
                            <Row :gutter="0" justify="center">
                                <Col span="1">
                                    <i class="fa fa-search" aria-hidden="true"></i>
                                </Col>
                                <Col span="21">
                                    <input placeholder="输入您要搜索的产品" v-model="searchValue"/>
                                </Col>
                                <Col span="2">
                                    <button class="search-button" @click="search()">搜索</button>
                                </Col>
                            </Row>
                        </div>
                        <div class="hot-word">
                            <strong>搜索热词:&nbsp;&nbsp;</strong>
                            <a v-for="(item, index) in words" @click="searchHot(item.word)">
                                {{item.word}}&nbsp;&nbsp;
                            </a>
                        </div>
                    </div>
                    <div class="gird-list">
                        <div v-for="(item, index) in list">
                            <a :href="item.url" target="_blank" v-if="!!item.url">
                                <img :src="item.thumbnail" alt="">
                                <p>{{ item.name }}</p>
                            </a>
                            <router-link v-else tag="a" target="_blank" :to="{name:'product-details', query: { product_id: item.id }}">
                                <img :src="item.thumbnail" alt="">
                                <p>{{ item.name }}</p>
                            </router-link>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    </div>
</template>

<script>
    import SubNav from './SubNav.vue'
    import * as product from '@/controller/product'

    export default {
        name: "category",
        components: { SubNav },
        data() {
            return {
                imgUrl: '',
                list:[],
                menuList: [],
                menuToggleStatus: false,
                searchValue:'',
                words: ''
            }
        },
        mounted() {
            this.showBanner()
            this.getProductList()
            this.hotWords()
        },
        methods: {
            showBanner() {
                product.fetchBanner()
                    .then(result => {
                        this.imgUrl = result.imgUrl.product
                    })
            },
            getProductList() {
                product.getProductList()
                    .then(result => {
                        // console.log(result)

                        for(let index in result) {
                            // console.log(result[index])

                            let obj = new Object()
                            obj.name = result[index].name
                            obj.id = result[index].id
                            obj.list = new Array()

                            if(index == 0) {
                                obj.show = true
                            } else {
                                obj.show = false
                            }

                            // console.log(result[index].detail)

                            for(let i in result[index].detail) {
                                // console.log(result[index].detail[i])

                                let subObj = new Object()
                                subObj.id = result[index].detail[i].id
                                subObj.name = result[index].detail[i].name
                                subObj.thumbnail = result[index].detail[i].thumbnail
                                subObj.url = result[index].detail[i].url

                                obj.list.push(subObj)

                            }

                            this.menuList.push(obj)

                        }

                        this.list = this.menuList[0].list

                        if(this.$route.query.index) {
                            for(let i = 0; i < this.menuList.length; i++) {
                                if(this.menuList[i].id == this.$route.query.id) {
                                    this.menuList[i].show = true
                                }else {
                                    this.menuList[i].show = false
                                }
                            }
                            this.list = this.menuList[this.$route.query.index].list
                        }
                    })
            },
            toggleMenu(item, index) {

                // 展开子菜单
                this.menuList.forEach(i => {

                    if(i.show != this.menuList[index].show) {
                        i.show = false
                    }
                })
                item.show = !item.show

                // 填充对应数据
                this.addList(item, index)

            },
            addList(item, index) {
                this.list = item.list
            },
            //搜索
            search() {
                if(this.searchValue != '') {
                    this.$router.push({ name: 'product-list', query: { words: this.searchValue }})
                }
            },
            searchHot(hotword) {
                this.$router.push({ name: 'product-list', query: { words: hotword }})
            },
            hotWords() {
                product.fetchHotWords()
                    .then(result => {
                        this.words = result.list
                    })
            }
        }
    }
</script>

<style scoped lang="stylus">
.profile-img
    background-color white
    overflow hidden
    img
        width 100%
.list-width
    width 1000px
    margin 0 auto
    padding 28px 0px
    .left-nav
        h1
            background-color #DB1232
            color white
            font-size 16px
            padding 4px
        ul
            display block
            list-style-type none
            margin 0
            padding 0
            outline none
            li
                display block
                overflow hidden
                position relative
                border-bottom 1px solid #F9F9F9
                border-right 1px solid #F9F9F9
                border-left 1px solid #F9F9F9
                a
                    display block
                    padding 8px
                    font-size 13px
                    color black
                    opacity 0.8
                    font-weight bold
                    transition:all 0.2s ease-in
                dl
                    display block
                    width 100%
                    text-align center
                    padding 0px
                    dd
                        background-color #F9F9F9
                        padding 4px
                        a
                            display block
                            font-weight normal
                            cursor pointer
                            transition: color .1s ease-in
                        .active
                            color #DB1232
                .bounce-enter-active
                    animation bounce-in .5s
                .bounce-leave-active
                    animation bounce-in .1s reverse
                @keyframes bounce-in {
                    from {
                        transform: scaleY(0)
                    }
                    to {
                        transform: scaleY(1)
                    }
                }
    .gird-list
        padding 20px
        div
            width 264px
            height 174px
            float left
            padding 0px 8px
            margin 6px 0px
            img
                display block
                width 100%
                height 140px
                background-color gray
            p
                display block
                background-color gainsboro
                text-align center
                padding 8px
                color black
    .search-bar
        border 1px solid #ED4114
        padding 3px
        border-radius 4px
        .search-button
            float right
            width 64px
            height 32px
            background-color #E5001F
            border none
            border-radius 4px
            color white
            outline none
            cursor pointer
        .search-button
            float right
            width 64px
            height 32px
            background-color #E5001F
            border none
            border-radius 4px
            color white
            outline none
            cursor pointer
        i
            color #DB1232
            font-size 18px
            margin-top 6px
        input
            width 100%
            height 32px
            outline none
            border none
    .hot-word
        font-size 14px
        text-align left
        margin 10px 0px
        p
            font-size 10px
            padding-top 10px
    .red
        color #DB1232
    a
        color gray
</style>
